var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DefaultButton, Label, PrimaryButton, Stack, TextField } from '@fluentui/react';
import { stackTokens } from '../styles';
import * as React from 'react';
import { useCallback, useState, useEffect } from 'react';
import { saveFuelLog, getVehicles, getLatestFuelLogs } from '../../services/server-api';
import { Dropdown } from '../../common/dropdown';
import { CurrencyInput } from '../currency-input';
import { FuelLogPreviewCard } from './fuel-log-preview-card';
import { todayAsISODate } from '../../common/date.utils';
export var LogFuelForm = function (_a) {
    var onClose = _a.onClose, onSave = _a.onSave;
    var _b = useLogFuelForm(onClose, onSave), fuelLog = _b.fuelLog, updateFuelLog = _b.updateFuelLog, updateVehicle = _b.updateVehicle, submitForm = _b.submitForm;
    var _c = useState(), vehicles = _c[0], setVehicles = _c[1];
    var _d = useState(), latestFuelLogs = _d[0], setLatestFuelLogs = _d[1];
    useEffect(function () {
        getVehicles().then(setVehicles);
    }, []);
    useEffect(function () {
        getLatestFuelLogs().then(setLatestFuelLogs);
    }, []);
    var previousFuelLog = latestFuelLogs && fuelLog ? latestFuelLogs[fuelLog.vehicleId] : null;
    var km = Math.max(fuelLog.odometer - (previousFuelLog === null || previousFuelLog === void 0 ? void 0 : previousFuelLog.odometer), 0);
    var kml = fuelLog.liters ? km / fuelLog.liters : null;
    var totalCost = fuelLog.liters * fuelLog.price;
    return (React.createElement("form", null,
        React.createElement(Stack, { tokens: stackTokens },
            React.createElement(Dropdown, { items: vehicles, onChange: updateVehicle, label: "Vehicle", value: fuelLog.vehicleId }),
            React.createElement(TextField, { label: "Odometer", value: fuelLog.odometer ? fuelLog.odometer.toString() : '', type: "number", name: "odometer", onChange: updateFuelLog }),
            React.createElement(TextField, { label: "Liters", value: fuelLog.liters ? fuelLog.liters.toString() : '', type: "number", name: "liters", onChange: updateFuelLog }),
            React.createElement(CurrencyInput, { amount: fuelLog.price, label: "Price", name: "price", onChange: updateFuelLog }),
            React.createElement(TextField, { label: "Notes", name: "note", value: fuelLog.note, multiline: true, onChange: updateFuelLog }),
            React.createElement(Label, null, "Preview"),
            React.createElement(FuelLogPreviewCard, { kilometersPerLiter: kml, kilometers: km, totalCost: totalCost }),
            React.createElement(Stack, { horizontal: true, tokens: stackTokens },
                React.createElement(PrimaryButton, { onClick: submitForm }, "Save"),
                React.createElement(DefaultButton, { onClick: onClose }, "Cancel")))));
};
function useLogFuelForm(onClose, onSave) {
    var _this = this;
    var _a = useState(initializeFuelLog()), fuelLog = _a[0], setFuelLog = _a[1];
    var updateFuelLog = useCallback(function (_a) {
        var _b;
        var target = _a.target;
        setFuelLog(__assign(__assign({}, fuelLog), (_b = {}, _b[target.name] = target.value, _b)));
    }, [fuelLog]);
    var updateVehicle = useCallback(function (id) {
        setFuelLog(__assign(__assign({}, fuelLog), { vehicleId: id }));
    }, [fuelLog]);
    var submitForm = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveFuelLog(fuelLog)];
                case 1:
                    _a.sent();
                    if (onSave) {
                        onSave();
                    }
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); }, [fuelLog, onClose, onSave]);
    return { fuelLog: fuelLog, updateFuelLog: updateFuelLog, updateVehicle: updateVehicle, submitForm: submitForm };
}
function initializeFuelLog() {
    var now = new Date();
    return {
        id: -1,
        paymentDate: todayAsISODate(),
        // for fuel log the payment date is ignored, and a utc timestamp is saved
        // it's created by the client so that a) it can potentially be overridden in the future,
        // b) it the timestamp and clientTzOffsetHrs are coupled
        timestamp: now,
        clientTzOffsetHrs: now.getTimezoneOffset() / -60,
        price: null,
        odometer: 0,
        liters: 0,
        note: '',
        isFull: true,
        vehicleId: null
    };
}
